// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__33PpJ","icon":"SortAdornment_icon__H_oaf","up":"SortAdornment_up__26EEa","down":"SortAdornment_down__318-u","active":"SortAdornment_active__2vyDE"};